export enum ImageParentType {
  CONTAINER = 'CONTAINER',
  PACKAGE = 'PACKAGE',
  PRODUCT = 'PRODUCT',
}
